import { useSnackbarsStore } from '../useSnackbarsStore/useSnackbarsStore'

export const useSnackbars = () => {
  const showAlert = useSnackbarsStore((store) => store.showAlert)
  const showError = useSnackbarsStore((store) => store.showError)
  const showWarning = useSnackbarsStore((store) => store.showWarning)
  const showInfo = useSnackbarsStore((store) => store.showInfo)
  const showUpsell = useSnackbarsStore((store) => store.showUpsell)
  const showApolloOrTextError = useSnackbarsStore((store) => store.showApolloOrTextError)
  const showSnackbar = useSnackbarsStore((store) => store.showSnackbar)
  const hideSnackbar = useSnackbarsStore((store) => store.hideSnackbar)
  const updateSnackbar = useSnackbarsStore((store) => store.updateSnackbar)

  return {
    showAlert,
    showError,
    showWarning,
    showInfo,
    showUpsell,
    showApolloOrTextError,
    showSnackbar,
    hideSnackbar,
    updateSnackbar,
  }
}
